(() => {
  const HC = (window.HC = window.HC || {});

  const init = (root) => {
    if (root.dataset.hcReady) return;
    root.dataset.hcReady = '1';

    // Gallery counter "(1/3)"
    const gallery = root.querySelector('[data-hc-gallery]');
    const counter = root.querySelector('[data-hc-gallery-counter]');
    if (gallery && counter) {
      const total = counter.dataset.total;
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        counter.textContent = '(' + (i + 1) + '/' + total + ')';
      }, { passive: true });
    }

    // Size sheet
    const sheet = root.querySelector('[data-hc-sheet]');
    const form = root.querySelector('[data-hc-product-form]');
    const idInput = root.querySelector('[data-hc-variant-id]');
    const sizeLabel = root.querySelector('[data-hc-size-label]');
    const addBtn = root.querySelector('[data-hc-add]');
    const openSheet = () => { if (sheet) sheet.hidden = false; };
    const closeSheet = () => HC.closeAnimated(sheet, 300);

    root.querySelectorAll('[data-hc-size-open]').forEach((b) => b.addEventListener('click', openSheet));
    root.querySelectorAll('[data-hc-sheet-close]').forEach((b) => b.addEventListener('click', closeSheet));
    root.querySelectorAll('[data-hc-size]').forEach((opt) => {
      opt.addEventListener('click', () => {
        if (opt.disabled) return;
        idInput.value = opt.dataset.variantId; idInput.dispatchEvent(new Event('change', { bubbles: true })); const hcX = root.querySelector('.hc-express'); if (hcX) hcX.classList.add('is-ready'); if (form) form.dataset.hcSized = '1';
        sizeLabel.textContent = 'Size ' + opt.dataset.hcSize;
        root.querySelectorAll('[data-hc-check]').forEach((c) => (c.hidden = c.closest('[data-hc-size]') !== opt));
        setTimeout(closeSheet, 160);
      });
    });

    // Sold out: "Notify me" subscribes the email to Klaviyo back-in-stock for the chosen size.
    const notify = root.querySelector('[data-hc-notify]');
    const subscribe = async () => {
      const email = notify.querySelector('[data-hc-notify-email]');
      const msg = notify.querySelector('[data-hc-notify-msg]');
      const say = (text, error) => { msg.textContent = text; msg.hidden = false; msg.classList.toggle('hc-notify__msg--error', !!error); };
      email.classList.remove('hc-input--error');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) { email.classList.add('hc-input--error'); say('Please enter a valid email address.', true); email.focus(); return; }
      if (addBtn.getAttribute('aria-busy') === 'true') return;
      addBtn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + notify.dataset.companyId, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({ data: {
            type: 'back-in-stock-subscription',
            attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email.value.trim() } } } },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + idInput.value } } },
          } }),
        });
        if (!res.ok) throw new Error(res.status);
        say("You're on the list. We'll email you when " + sizeLabel.textContent.replace(/^Size /, 'size ') + ' is back.');
        email.value = '';
      } catch (err) {
        say('Something went wrong. Please try again.', true);
      } finally {
        addBtn.removeAttribute('aria-busy');
      }
    };

    // Add to bag: open the size sheet if no size is picked, else add and open the bag drawer.
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!idInput.value || !form.dataset.hcSized) { openSheet(); return; }
        if (notify) { subscribe(); return; }
        if (addBtn.getAttribute('aria-busy') === 'true') return;
        addBtn.setAttribute('aria-busy', 'true');
        try {
          await HC.addToBag(idInput.value, 1);
        } finally {
          addBtn.removeAttribute('aria-busy');
        }
      });
    }

    // Accordions: one open at a time, all closed by default.
    const acc = root.querySelector('[data-hc-accordion]');
    if (acc) {
      acc.querySelectorAll('.hc-acc__btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const open = btn.getAttribute('aria-expanded') !== 'true';
          acc.querySelectorAll('.hc-acc__btn').forEach((b) => {
            const on = b === btn && open;
            b.setAttribute('aria-expanded', String(on));
            b.querySelector('[data-hc-glyph]').textContent = on ? '–' : '+';
            document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
          });
        });
      });
    }

    // Full-screen detail panels (separates)
    root.querySelectorAll('[data-hc-panel-open]').forEach((b) => {
      b.addEventListener('click', () => {
        const panel = root.querySelector('[data-hc-panel="' + b.dataset.hcPanelOpen + '"]');
        if (panel) { panel.hidden = false; panel.scrollTop = 0; }
      });
    });
    root.querySelectorAll('[data-hc-panel-close]').forEach((b) => {
      b.addEventListener('click', () => HC.closeAnimated(b.closest('[data-hc-panel]'), 320));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeSheet();
      root.querySelectorAll('[data-hc-panel]:not([hidden])').forEach((p) => HC.closeAnimated(p, 320));
    });
  };

  const boot = () => document.querySelectorAll('[data-hc-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
